export enum KnmWebNotificationTypesEnum {
  VP = 'VP',
  AGREEMENT = 'AGREEMENT',
  VP_AGREEMENT = 'VP_AGREEMENT',
  VP_AGREEMENT_4_1_37 = 'VP_AGREEMENT_4_1_37',
  PLAN_GENERAL = 'PLAN_GENERAL',
  PLAN_GENERAL_AGREEMENT = 'PLAN_GENERAL_AGREEMENT',
  PLAN_GENERAL_CHANGE = 'PLAN_GENERAL_CHANGE',
  PLAN_GENERAL_ADD = 'PLAN_GENERAL_ADD',
  PLAN_GENERAL_ADD_AGREEMENT = 'PLAN_GENERAL_ADD_AGREEMENT',
  APPEAL = 'APPEAL',
}
